import { render, staticRenderFns } from "./studataDetail.vue?vue&type=template&id=ec189c04&"
import script from "./studataDetail.vue?vue&type=script&lang=js&"
export * from "./studataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports